import React, { useContext } from 'react';
import {
  Box,
  Grid,
  ResponsiveContext,
  Page,
  PageContent,
  Footer,
  PageHeader,
  Text,
} from 'grommet';

import {
  UserSessions,
  UpTime,
  PageViewsCountry,
  AverageResponseTimes,
  SaaSQuoteStatus,
  HWLedQuoteStatus,
} from './../content/home';

import { AppFooter } from '../components';

/* -------------------------------------------------------
   Page
------------------------------------------------------- */

const HomePage = () => (
  <Page background="background-back" flex="grow">
    <PageContent>
      <PageHeader
        title="Hello"
        size="medium"
        pad={{ vertical: 'small' }}
        subtitle="Welcome to the EaaS Operations Console."
      />

      <Content />
    </PageContent>

    <Footer
      pad={{ horizontal: 'medium', top: 'medium', bottom: 'xsmall' }}
      justify="center"
    >
      <Text size="11pt" style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
        Powered by ITaaS
      </Text>
    </Footer>

    <AppFooter />
  </Page>
);

/* -------------------------------------------------------
   Content
------------------------------------------------------- */

const Content = () => {
  const size = useContext(ResponsiveContext);
  const isMobile = size === 'xxsmall' || size === 'xsmall' || size === 'small';

  return (
    <main>
      {/* ================= KPIs ================= */}
      <Box>
        <Grid
          columns={isMobile ? ['100%'] : ['1/3', '1/3', '1/3']}
          gap="medium"
        >
          <UpTime />
          <UserSessions />
          <PageViewsCountry />
        </Grid>
      </Box>

      {/* ========== RESPONSE + SAAS ========== */}
      <Box pad={{ top: 'medium' }}>
        <Grid
          columns={isMobile ? ['100%'] : ['2/3', '1/3']}
          gap="medium"
        >
          <AverageResponseTimes />
          <SaaSQuoteStatus />
        </Grid>
      </Box>

      {/* ========== HW LED (FULL WIDTH) ========== */}
      <Box pad={{ top: 'medium' }}>
        <Grid columns={['100%']} gap="medium">
          <HWLedQuoteStatus />
        </Grid>
      </Box>
    </main>
  );
};

export { HomePage as Home };

